































import { Vue, Component, Prop } from "vue-property-decorator";
import Page from "@/views/Page.vue";
import { generalSettings, catalogueSettings } from "@/models/Setting";
import { camelToUnderscore } from "../utils/Typography";

@Component({ components: { Page } })
export default class Settings extends Vue {
  get general() {
    return generalSettings;
  }

  get catalogue() {
    return catalogueSettings;
  }

  onCatalogueSettingClicked(param) {
    this.$router.push({
      name: "catalogue_setting",
      params: { section: camelToUnderscore(param.type) },
    });
  }
}
